module.exports = __webpack_public_path__ + "akne_4_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/akne_4_after_tn.jpg
// module id = 1389
// module chunks = 0